/* ======================  SCRIPTS ====================== */
/************  JQUERY EST DISPONIBLE ICI *****************/

    $('document').ready(setup);

    function setup() {
        $('a').click(goToAnchor);
        $('.btn-topage, #topPage').click(goTopPage);
        $('.buttonAsLink').click(function() {
            if($(this).attr('data-url') !== '#cookies') {
                window.open($(this).attr('data-url'), '_self');
            }else {
                tarteaucitron.userInterface.openPanel();
            }
        });
        jQuery('p:empty').not('[role="status"]').remove();
        $('.lightBoxVideoLink').simpleLightbox({videoRegex: new RegExp(/youtube.com|youtube-nocookie.com|player.vimeo.com|vimeo.com/)});
    }
    
    // Animation pour aller aux ancres
    function goToAnchor(e) {
        var url = $(this).attr('href');
        var target = $(this).attr('target');
        if(url && url !== '#' && url.indexOf('#') !== -1 && target !=='_blank') {
            var id = url.split('#')[1];
            if(id.indexOf('/') === -1 && id !== '' && $('#'+id).length !== 0) {
                e.preventDefault();
                if($('.joboffers-offer.show').length !== 0 && $(window).width() < 1000) {
                    var scrollOffset = $('.joboffers-offer.show #' + id)[0].offsetTop - $('.joboffers-offer.show')[0].offsetTop;
                    $('.joboffers-offer.show').animate({ scrollTop: scrollOffset + 50 }, 500);
                }else {
                    var offset = $('#'+id).offset().top - 150;
                    $('html, body').animate({scrollTop: offset}, 1000);
                }
            }
        }
    }

    // Retour en haut de page
    function goTopPage() {
        if($('.joboffers-offer.show').length !== 0 && $(window).width() < 1000) {
            $('.joboffers-offer.show').animate({scrollTop: 0}, 1500);
        }else {
            $('html, body').animate({scrollTop: 0}, 1500);
        }
    }
